import { useUpdateUserInfo, useUserInfo } from '@/services/user/hooks';
import rem from '@/utils/rem';
import { Text, Textarea, VStack, useToast } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function CaptureThrive() {
  const { t } = useTranslation('CaptureThrive');
  const toast = useToast();
  const [captureThriveText, setCaptureThriveText] = useState('');
  const { data: userInfo } = useUserInfo();
  const updateUserInfo = useUpdateUserInfo();

  const handleSubmit = useCallback(() => {
    if (!userInfo?.me?.id) {
      return;
    }

    updateUserInfo.mutate(
      {
        id: userInfo.me.id,
        soundsEnabled: userInfo?.me.soundsEnabled ?? false,
        toThrive: captureThriveText,
        language: userInfo?.me.language ?? 'en',
        isAllowedFeatureFlag: userInfo?.me.isAllowedFeatureFlag ?? false,
        areActionsPrivate: userInfo?.me.areActionsPrivate ?? true,
      },
      {
        onSuccess: () => {
          toast({
            title: t('toasts.saved'),
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
        },
        onError: (error) => {
          toast({
            title: error?.response?.errors?.[0]?.message ?? t('toasts.error'),
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        },
      },
    );
  }, [updateUserInfo, userInfo?.me?.id, userInfo?.me.soundsEnabled, captureThriveText, toast, t]);

  useEffect(() => {
    setCaptureThriveText(userInfo?.me.toThrive ?? '');
  }, [userInfo?.me?.toThrive, setCaptureThriveText]);

  return (
    <VStack
      alignItems="start"
      gap={rem(16)}
      overflow="hidden"
      width="full"
      borderRadius={rem(8)}
      backdropFilter="blur(4px)"
      backgroundColor="background-tertiary"
      paddingX={rem(32)}
      paddingY={rem(24)}
    >
      <Text textStyle="mediumBlack" align="center" width="full">
        {t('labels.title')}
      </Text>
      <Textarea
        width="full"
        minHeight={rem(310)}
        padding={rem(12)}
        fontSize={rem(12)}
        fontWeight={500}
        lineHeight="130%"
        border={'none'}
        borderRadius={rem(8)}
        resize="none"
        backgroundColor="background-default"
        maxLength={10000}
        onBlur={handleSubmit}
        onChange={(e) => setCaptureThriveText(e.target.value)}
        value={captureThriveText}
      />
    </VStack>
  );
}

export default CaptureThrive;
